import React from 'react'
import { createRoot } from 'react-dom/client'
import './translations/i18n'
import App from './App'
import moment from 'moment-timezone'

moment.tz.setDefault('Europe/Madrid')

window.jwt = ''

const container = document.getElementById("root")
if (!container) {
	throw new Error("No se encontró el elemento root en el DOM")
}

const root = createRoot(container)

root.render(
	<React.StrictMode>
		<App />
	</React.StrictMode>
)